import Footer from 'components/common/Footer'
import MenuBar from 'components/menu-bar/MenuBar'
import TopNav from 'components/top-nav/TopNav'
import { Outlet } from 'react-router'

function AppLayout() {
  return (
    <div className="d-flex flex-column min-vh-100">
      <TopNav />
      <MenuBar />

      <main className="main flex-grow-1 mb-3">
        <div className="container-fluid px-5">
          <Outlet />
        </div>
      </main>
      <Footer />
    </div>
  )
}

export default AppLayout
